// extracted by mini-css-extract-plugin
export var thumbnailwrapper = "embedyoutube-module--thumbnailwrapper--3bab3";
export var youtube = "embedyoutube-module--youtube--61393";
export var youtubelogo = "embedyoutube-module--youtubelogo--7533e";
export var youtubewrapper = "embedyoutube-module--youtubewrapper--9fb17";